import React from 'react';
import { ProfileTab } from 'types/interfaces/profile';
import { AssetUrls } from 'config/assets';
import './ProfileTabs.css';

interface ProfileTabsProps {
  activeTab: ProfileTab;
  onTabChange: (tab: ProfileTab) => void;
  showHaveList: boolean;
}

interface TabConfig {
  id: ProfileTab;
  label: string;
  icon: string;
}

const TABS: TabConfig[] = [
  { id: 'history', label: 'Trade History', icon: 'SendCards/icon-completed.svg' },
  { id: 'want', label: 'Want List', icon: 'heart.svg' },
  { id: 'have', label: 'Have List', icon: 'have.svg' },
];

export const ProfileTabs: React.FC<ProfileTabsProps> = ({
  activeTab,
  onTabChange,
  showHaveList,
}) => {
  const visibleTabs = TABS.filter((tab) => tab.id !== 'have' || showHaveList);

  return (
    <div className="profile-tabs">
      {visibleTabs.map((tab) => (
        <button
          key={tab.id}
          className={`profile-tab ${activeTab === tab.id ? 'active' : ''}`}
          onClick={() => onTabChange(tab.id)}
        >
          <img
            src={`${AssetUrls.base}/assets/icons/${tab.icon}`}
            alt={tab.label}
            className="profile-tab-icon"
            onError={(e) => {
              (e.target as HTMLImageElement).style.display = 'none';
            }}
          />
          <span className="profile-tab-label">{tab.label}</span>
        </button>
      ))}
    </div>
  );
};

export default ProfileTabs;
